// export const url = "http://localhost:3601/api";
// export const url = "https://rare-shadow-276706.uc.r.appspot.com/api";
export const url = "https://athgcp.acumenvelocity.com/api";
// export const url = "https://firestore-demo-277216.ue.r.appspot.com/api";

// export const v2Url = "http://localhost:3001";
export const v2Url = "https://athteamgcp.acumenvelocity.com";
// export const v2Url = "https://teams-dot-rare-shadow-276706.uc.r.appspot.com";
// export const v2Url = "https://teams-dot-firestore-demo-277216.ue.r.appspot.com";

// export const googleClientId = "1068828783420-sfpt6hp9g3ga6e6ohem8rr3dn1in4qes.apps.googleusercontent.com";
// export const GOOGLE_API_KEY = "AIzaSyCSAL65TG8QE2GMuhi_XxXzMOkDXLtPfsQ"; //firestore
// export const PROJECT_ID = 'firestore-demo-277216';

export const googleClientId = "818247973279-fnppb9ffge0odmrtie9gid4q392asdlf.apps.googleusercontent.com"
export const GOOGLE_API_KEY = 'AIzaSyAr1CJ3ztX4RHr5O9z5IHeNQ6cGNRAR4LY'; // rare-shadow-276706
export const PROJECT_ID = 'rare-shadow-276706';
